<div>
  <i mat-dialog-close class="close icon"></i>
  <span class="cant-comentarios">Seleccione una opción </span>
  <mat-dialog-content style="margin-top:1em;min-width: 30vw;" class="mat-typography">
    <div class="ui input" style="width: 100%;">
      <input disabled *ngIf="esEjecutor" type="text" [(ngModel)]="userSelected">

      <input #userInput *ngIf="!esEjecutor" type="text" matInput [formControl]="userCtrl" [matAutocomplete]="auto"
        placeholder="Seleccionar usuario" (click)="openAutocomplete()">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="userSelected = $event.option.value">
        <ng-container *ngIf="filteredUsers.length > 0; else noResults">
          <mat-option *ngFor="let user of filteredUsers" [value]="user">
            {{ user }}
          </mat-option>
        </ng-container>
        <ng-template #noResults>
          <mat-option disabled *ngIf="userCtrl.value">No se encontraron usuarios</mat-option>
        </ng-template>
      </mat-autocomplete>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="asignar()" class="ui  button  primary">
      Guardar
    </button>
  </mat-dialog-actions>

</div>